import { render, staticRenderFns } from "./PessoaConexaoFtpForm.vue?vue&type=template&id=386495fa"
import script from "./PessoaConexaoFtpForm.vue?vue&type=script&lang=js"
export * from "./PessoaConexaoFtpForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports